module.exports = __webpack_public_path__ + "static/media/tc.c5f877e2.svg";